module.exports = __webpack_public_path__ + "img/frontend_developer.40a4fd3c.svg";